import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Home from './components/Home';
import Dashboard from './pages/Dashboard';
import Papers from './pages/Papers';
import Papersedit from './pages/Papersedit';
import Prebuild from './pages/Prebuild';
import Mypaper from './pages/Mypaper';
import Draftpaper from './pages/draftpaper';
import Questions from './pages/Questions';
import Selectregularpaper from './pages/selectregularpaper';
import Selectregularpaperedit from './pages/selectregularpaperedit';
import Regularpaper from './pages/Regularpaper';
import Regularpaperedit from './pages/Regularpaperedit';
import Expertpaper from './pages/Expertpaper';
import Expertpreview from './pages/Expertpreview';
import Mcq from './pages/Mcq';
import Fillblank from './pages/Fillblank';
import Fillblankedit from './pages/Fillblankedit';
import Truefalse from './pages/Truefalse';
import Veryshortans from './pages/Veryshortans';
import Shortans from './pages/Shortans';
import Longtans from './pages/Longans';
import Matching from './pages/Matching';
import Diagram from './pages/Diagram';
import Mcqedit from './pages/Mcqedit';
import Truefalseedit from './pages/Truefalseedit';
import Veryshortansedit from './pages/Veryshortansedit';
import Shortansedit from './pages/Shortansedit';
import Longtansedit from './pages/Longansedit';
import Matchingedit from './pages/Matchingedit';
import Diagramedit from './pages/Diagramedit';
import Preview from './pages/Preview';
import Previewedit from './pages/Previewedit';
import Createque from './pages/Createque';
import Queedit from './pages/Queedit';
import Myque from './pages/Myquestion';
import CustomCursor from "./components/CustomCursor";


function App() {
  return (
    <Router>
      {/* ✅ Custom Cursor should be inside Router so it’s part of the app tree */}
      <CustomCursor />

      {/* ✅ ToastContainer */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      {/* ✅ Routes */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/papers/" element={<Papers />} />
        <Route path="/papersedit/:id" element={<Papersedit />} />
        <Route path="/papers/prebuild/" element={<Prebuild />} />
        <Route path="/papers/mypapers/" element={<Mypaper />} />
        <Route path="/papers/draftpaper/" element={<Draftpaper />} />
        <Route path="/questions/" element={<Questions />} />
        <Route path="/selectregularpaper/" element={<Selectregularpaper />} />
        <Route path="/selectregularpaperedit/:id" element={<Selectregularpaperedit />} />
        <Route path="/regularpaper/" element={<Regularpaper />} />
        <Route path="/regularpaperedit/:paperId" element={<Regularpaperedit />} />
        <Route path="/expertpaper/" element={<Expertpaper />} />
        <Route path="/expertpreview/" element={<Expertpreview />} />
        <Route path="/mcq/" element={<Mcq />} />
         <Route path="/mcqedit/" element={<Mcqedit />} />
        <Route path="/fill-blanks/" element={<Fillblank />} />
        <Route path="/fill-blanksedit/" element={<Fillblankedit />} />
        <Route path="/true-false/" element={<Truefalse />} />
         <Route path="/true-falseedit/" element={<Truefalseedit />} /> 
        <Route path="/short-answers/" element={<Shortans />} />
        <Route path="/veryshort-answers/" element={<Veryshortans />} />
        <Route path="/long-answers/" element={<Longtans />} />
        <Route path="/matching/" element={<Matching />} />
        <Route path="/diagram/" element={<Diagram />} />
        <Route path="/short-answersedit/" element={<Shortansedit />} />
        <Route path="/veryshort-answersedit/" element={<Veryshortansedit />} />
        <Route path="/long-answersedit/" element={<Longtansedit />} />
        <Route path="/matchingedit/" element={<Matchingedit />} />
        <Route path="/diagramedit/" element={<Diagramedit />} />
        <Route path="/preview/" element={<Preview />} />
        <Route path="/previewedit/:id" element={<Previewedit />} />
        <Route path="/questions/createque" element={<Createque />} />
        <Route path="/questions/queedit/:id" element={<Queedit />} />
        <Route path="/questions/myquestions" element={<Myque />} />
        
      </Routes>
    </Router>
  );
}

export default App;
